export const PRIMITIVE_COLOR_PALETTES = {
    alpha: {
        base: {
            cell: { counted: 'red', uncounted: 'green' },
            placeholder: { outline: '#0f172a' },
            label: { text: '#0f172a' },
            backgroundColor: 'skyblue',
            emphasis: { color: 'white' },
        },
        boolean: {
            decisiveOutline: { color: 'yellow' },
        },
        natural: {
            cell: { overhang: 'white', zero: '#000000', deficitMarker: '#000000' },
            comparison: { ray: 'yellow', decisiveCell: '#22c55e', helperCircleOutline: 'black' },
            canonicalZeroMarker: { color: '#0f172a' },
            axialTie: { color: '#0f172a' },
            axisRod: { color: '#0f172a' },
        },
    },
    // Deep ocean: teal inputs, coral outputs, and warm gold accents.
    beta: {
        base: {
            cell: { counted: '#e76f51', uncounted: '#2a9d8f' },
            placeholder: { outline: '#9fb3c8' },
            label: { text: '#f7fafc' },
            backgroundColor: '#102a43',
            emphasis: { color: '#f7fafc' },
        },
        boolean: {
            decisiveOutline: { color: '#ffd166' },
        },
        natural: {
            cell: { overhang: 'pink', zero: '#bcccdc', deficitMarker: '#ffd166' },
            comparison: { ray: '#ffd166', decisiveCell: '#7bdff2', helperCircleOutline: '#9fb3c8' },
            canonicalZeroMarker: { color: '#bcccdc' },
            axialTie: { color: '#829ab1' },
            axisRod: { color: '#829ab1' },
        },
    },
    // Warm porcelain: forest green and terracotta on a light neutral ground.
    gamma: {
        base: {
            cell: { counted: '#c65d3b', uncounted: '#287a67' },
            placeholder: { outline: '#8b7765' },
            label: { text: '#342f2a' },
            backgroundColor: '#f3eee5',
            emphasis: { color: '#1f1b16' },
        },
        boolean: {
            decisiveOutline: { color: '#b7791f' },
        },
        natural: {
            cell: { overhang: '#d9b984', zero: '#5f574f', deficitMarker: '#9d3152' },
            comparison: { ray: '#b7791f', decisiveCell: '#176b81', helperCircleOutline: '#8b7765' },
            canonicalZeroMarker: { color: '#5f574f' },
            axialTie: { color: '#8b7765' },
            axisRod: { color: '#8b7765' },
        },
    },
    // Midnight violet: mint, rose, and lavender accents.
    delta: {
        base: {
            cell: { counted: '#ef8fb0', uncounted: '#68d5b5' },
            placeholder: { outline: '#a99bc5' },
            label: { text: '#f4efff' },
            backgroundColor: '#211a33',
            emphasis: { color: '#ffffff' },
        },
        boolean: {
            decisiveOutline: { color: '#ffe08a' },
        },
        natural: {
            cell: { overhang: '#c4b5fd', zero: '#ddd4ee', deficitMarker: '#ffb38a' },
            comparison: { ray: '#ffe08a', decisiveCell: '#8ac8ff', helperCircleOutline: '#a99bc5' },
            canonicalZeroMarker: { color: '#ddd4ee' },
            axialTie: { color: '#a99bc5' },
            axisRod: { color: '#a99bc5' },
        },
    },
    // Nordic mist: blue and raspberry on cool pale grey.
    epsilon: {
        base: {
            cell: { counted: '#b84a70', uncounted: '#347fa3' },
            placeholder: { outline: '#647b89' },
            label: { text: '#253b49' },
            backgroundColor: '#eaf1f4',
            emphasis: { color: '#10202a' },
        },
        boolean: {
            decisiveOutline: { color: '#a66a00' },
        },
        natural: {
            cell: { overhang: '#94b9c9', zero: '#536b79', deficitMarker: '#a66a00' },
            comparison: { ray: '#a66a00', decisiveCell: '#267a65', helperCircleOutline: '#647b89' },
            canonicalZeroMarker: { color: '#536b79' },
            axialTie: { color: '#647b89' },
            axisRod: { color: '#647b89' },
        },
    },
} as const;
